import { Formik, Form } from 'formik';
import { useServices } from '@services';
import { Modal, FormInput, Button, InputImage, Label } from '@component';
import { showImageUpload } from './constants';
import { toast } from 'react-toastify';
import { generateQuizId } from '@utils/quiz';

export const QuizForm = ({ quiz, onClose, saved }) => {
  const { db } = useServices();

  const initial = { name: '', imagePath: '', ...quiz };

  const validate = values => {
    const errors = {};
    if (!values.name) errors.name = 'Required';
    return errors;
  };

  const submit = (values, { setSubmitting }) => {
    const id = values.id || generateQuizId(values.name);
    const timestamp = Math.floor(Date.now() / 1000);
    const data = {
      ...values,
      id,
      modifiedOn: timestamp,
      createdOn: values.createdOn || timestamp,
      questionCount: values.questionCount || 0
    };
    const check = values.id
      ? Promise.resolve({ empty: true })
      : db.collection('quizData').where('name', '==', values.name).limit(1).get();

    check
      .then(snapshot => {
        if (!snapshot.empty) {
          toast.error('Quiz with this name already exists');
          setSubmitting(false);
          return;
        }
        db.collection('quizData')
          .doc(id)
          .set(data)
          .then(() => db.updateQuizModifiedOn())
          .then(() => {
            toast.success('Quiz saved');
            saved();
            onClose();
          })
          .catch(() => toast.error('Failed to save quiz'))
          .finally(() => setSubmitting(false));
      })
      .catch(() => {
        toast.error('Failed to save quiz');
        setSubmitting(false);
      });
  };

  return (
    <Modal visible={!!quiz} onClose={onClose} title={quiz?.id ? 'Edit Quiz' : 'Add Quiz'} className="text-black w-full max-w-3xl">
      <Formik initialValues={initial} validate={validate} onSubmit={submit} enableReinitialize>
        {({ values, isSubmitting, setFieldValue }) => (
          <Form>
            <Label htmlFor="name">Name *</Label>
            <FormInput name="name" />
            {showImageUpload && (
              <>
                <Label className="mt-4">Image</Label>
                <InputImage
                  imageUrl={values.imagePath}
                  storagePath={`quizData/${values.id || 'new'}`}
                  onChange={url => setFieldValue('imagePath', url)}
                  height="256px"
                />
              </>
            )}
            <div className="flex justify-end">
              <Button type="submit" disabled={isSubmitting} className="mt-4">
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};